<ts-resource-editor [resource]="data" [embedInCard]="false" (submitted)="closeDialog($event)"> </ts-resource-editor>
